import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { IPmFormConducting } from '../interfaces/IPmFormConducting';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { handleResponse } from '../../MainModule/common/handleResponse';

export async function fetchPmFormsConducting(): Promise<IPmFormConducting[]> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/pm-form-conducting`;
  const mockData = apiMockSwitcher<IPmFormConducting[]>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
